import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { DATE_FULL_FORMAT } from '../../../../../../constants/date'
import { getQaSelector } from '../../../../../../utils/common'
import { EntityLink, EntityStatus } from '../../../../../Entity'
import { FloatingTooltip } from '../../../../../Floating'
import {
  getListingPublicationErrorText,
  LISTING_PUBLICATION_SYNC_STATUSES,
} from '../../../../../RentalPortalListing'
import {
  TableCellBase,
  TableDateCell,
  TableTextCell,
} from '../../../../../Table'
import { ListingProfilePublishingsActionsCell } from '../ListingProfilePublishingsActionsCell'
import { ListingProfilePublishingsPortalCell } from '../ListingProfilePublishingsPortalCell'
import { LISTING_PUBLICATION_COLUMN_NAME } from '../RentalPortalListingProfilePublishings.constants'
import { getIsListingPublicationSyncFailed } from '../RentalPortalListingProfilePublishings.utils'

import { QA_NAME_LISTING_PROFILE_PUBLISHINGS_OPEN_AD } from './ListingProfilePublishingsRow.constants'

function getListingPublicationStatusTooltip({ publication, t }) {
  return getIsListingPublicationSyncFailed(publication)
    ? getListingPublicationErrorText({ publication, t })
    : null
}

export function getIsListingPublicationRowActive({ focusedRow, item }) {
  return focusedRow === item.id
}

export function renderListingProfilePublishingsCell({
  actions,
  item,
  name,
  openAdLinkClassName,
  scheduledTextClassName,
  t,
  onCallAction,
  ...restProps
}) {
  const { [name]: value } = item

  switch (name) {
    case LISTING_PUBLICATION_COLUMN_NAME.Portal:
      return (
        <ListingProfilePublishingsPortalCell
          {...restProps}
          publication={item}
        />
      )

    case LISTING_PUBLICATION_COLUMN_NAME.Status:
      return (
        <FloatingTooltip
          content={getListingPublicationStatusTooltip({ publication: item, t })}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <TableCellBase {...restProps}>
            <EntityStatus
              id={value}
              statuses={LISTING_PUBLICATION_SYNC_STATUSES}
            />
          </TableCellBase>
        </FloatingTooltip>
      )

    case LISTING_PUBLICATION_COLUMN_NAME.ExternalId:
      return (
        <TableTextCell {...restProps} value={value}>
          {item.public_url ? (
            <EntityLink
              {...getQaSelector({
                context: item.id,
                value: QA_NAME_LISTING_PROFILE_PUBLISHINGS_OPEN_AD,
              })}
              className={openAdLinkClassName}
              to={item.public_url}
              tooltip={t(
                'RentalPortal.ListingProfilePublishingsOpenAdTooltipKey'
              )}
            />
          ) : null}
        </TableTextCell>
      )

    case LISTING_PUBLICATION_COLUMN_NAME.Scheduled:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_FULL_FORMAT}
          textCellProps={{ className: scheduledTextClassName }}
          value={value}
        />
      )

    case LISTING_PUBLICATION_COLUMN_NAME.LastSync:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_FULL_FORMAT}
          value={value}
        />
      )

    case LISTING_PUBLICATION_COLUMN_NAME.Actions:
      return (
        <ListingProfilePublishingsActionsCell
          {...restProps}
          {...actions}
          onCallAction={onCallAction}
        />
      )

    default:
      return <TableTextCell {...restProps} value={value} />
  }
}
